<template>
  <div>
    <v-dialog v-model="resetSuccess" width="400" :fullscreen="$vuetify.breakpoint.mobile">
      <v-card>
        <v-card-title class="headline">Password Reset</v-card-title>
        <v-card-text>Completed Successfully</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeSuccessDialog()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  <v-dialog v-model="resetFailed" width="400" :fullscreen="$vuetify.breakpoint.mobile">
      <v-card>
        <v-card-title class="headline">Password Reset</v-card-title>
        <v-card-text>Failed to reset password</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="resetFailed = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    

    <v-row justify-md="center">
      <v-col sm="10" md="5">
        <div>
          <div class="d-flex justify-space-between">
            <h1>Reset Password</h1>
          </div>
          <form @submit.prevent="onSubmit" name="form">
            <v-text-field
              v-model="password"
              type="password"
              :error-messages="passwordErrors"
              placeholder="*******"
              label="Password"
              required
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
            />

            <v-text-field
              v-model="passwordRepeat"
              type="password"
              :error-messages="passwordRepeatErrors"
              placeholder="*******"
              label="Repeat password"
              required
              @input="$v.passwordRepeat.$touch()"
              @blur="$v.passwordRepeat.$touch()"
            />
            <div class="d-flex justify-space-between">
              <v-btn type="submit" :disabled="$v.$invalid">Reset Password</v-btn>
            </div>
          </form>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import { createFormErrors } from "../util";

export default {
  name: "ResetPassword",
  data() {
    return {
      password: "",
      passwordRepeat: "",
      resetSuccess: false,
      resetFailed: false,
    };
  },
  validations() {
    return {
      password: {
        required,
        minLength: minLength(4),
      },
      passwordRepeat: {
        required,
        minLength: minLength(4),
        sameAs: sameAs("password"),
      },
    };
  },
  computed: {
    passwordErrors() {
      return createFormErrors(this.$v.password);
    },
    passwordRepeatErrors() {
      return createFormErrors(this.$v.passwordRepeat);
    },
  },
  methods: {
    closeSuccessDialog() {
      this.resetSuccess = false;
      this.$router.replace("/");
    },
    onSubmit() {
      const token = this.$route.query.token;
      this.$store
        .dispatch("auth/resetPassword", {
          token: token,
          password: this.password,
        })
        .then(
          () => {
            //alert("Password reset succesfully");
            this.resetSuccess = true;
          },
          () => {
            this.resetFailed = true;
          }
        );
    },
  },
};
</script>